import React from 'react';
import './PopupModal.css';

const PopupModal = ({ message, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-modal">
        <p>{message}</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default PopupModal;
